module.exports = __webpack_public_path__ + "static/img/hw3.46c744a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/hw/hw3.png
// module id = mevC
// module chunks = 0